/* Portada móvil: pista nativa disponible desde el HTML, sin montaje de
   Swiper durante el scroll vertical. Conserva tarjetas, flechas y teclado. */
(function () {
  'use strict';
  if (window.miMontarRielMovil) return;
  var movil = window.matchMedia('(max-width: 809px)');
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.miRielMovilNativo = function (riel) {
    return movil.matches && !!riel.closest('.mi-riel--colecciones');
  };
  window.miMontarRielMovil = function (riel, nav) {
    var pista = riel.querySelector('.swiper-wrapper');
    if (!pista) return null;
    var pendiente = null;
    var anchoVentana = window.innerWidth;
    var tabindex = pista.getAttribute('tabindex');
    var api = {
      el: riel, miNativo: true, destroyed: false, animating: false,
      params: { cssMode: true }, activeIndex: 0,
      isBeginning: true, isEnd: pista.children.length <= 2,
      isLocked: pista.children.length <= 2
    };
    riel.dataset.miNativo = '1';
    pista.setAttribute('tabindex', '0');

    var pasoCache = 0;
    function medirPaso() {
      var tarjeta = pista.firstElementChild;
      return tarjeta ? tarjeta.getBoundingClientRect().width +
        (parseFloat(getComputedStyle(pista).columnGap) || 0) : pista.clientWidth;
    }
    function paso() { return pasoCache || (pasoCache = medirPaso()); }
    function pintarExtremos() {
      pendiente = null;
      if (api.destroyed || !riel.isConnected) return;
      var maximo = Math.max(0, pista.scrollWidth - pista.clientWidth);
      var posicion = pista.scrollLeft;
      api.isLocked = maximo <= 2;
      api.isBeginning = posicion <= 2;
      api.isEnd = posicion >= maximo - 2;
      api.activeIndex = Math.max(0, Math.round(posicion / (paso() || 1)));
      if (nav.prev && nav.prev.disabled !== (api.isBeginning || api.isLocked)) {
        nav.prev.disabled = api.isBeginning || api.isLocked;
      }
      if (nav.next && nav.next.disabled !== (api.isEnd || api.isLocked)) {
        nav.next.disabled = api.isEnd || api.isLocked;
      }
    }
    function programar() {
      if (pendiente === null && !api.destroyed) pendiente = requestAnimationFrame(pintarExtremos);
    }
    function ir(destino, instantaneo) {
      var maximo = Math.max(0, pista.scrollWidth - pista.clientWidth);
      pista.scrollTo({ left: Math.max(0, Math.min(maximo, destino)),
        behavior: instantaneo || quieto.matches ? 'auto' : 'smooth' });
      programar();
    }
    api.slideNext = function () { ir((Math.round(pista.scrollLeft / (paso() || 1)) + 1) * paso()); };
    api.slidePrev = function () { ir((Math.round(pista.scrollLeft / (paso() || 1)) - 1) * paso()); };
    api.slideTo = function (indice, velocidad) { ir(indice * paso(), velocidad === 0); };
    api.update = function () { pasoCache = 0; programar(); };
    function alCambiarAncho() {
      if (window.innerWidth === anchoVentana) return;
      anchoVentana = window.innerWidth;
      pasoCache = 0;
      programar();
    }
    function teclado(evento) {
      if (evento.target !== pista) return;
      if (evento.key === 'ArrowRight') api.slideNext();
      else if (evento.key === 'ArrowLeft') api.slidePrev();
      else if (evento.key === 'Home') api.slideTo(0);
      else if (evento.key === 'End') ir(pista.scrollWidth);
      else return;
      evento.preventDefault();
    }
    api.destroy = function () {
      api.destroyed = true;
      if (pendiente !== null) cancelAnimationFrame(pendiente);
      pista.removeEventListener('scroll', programar);
      pista.removeEventListener('keydown', teclado);
      window.removeEventListener('resize', alCambiarAncho);
      if (tabindex === null) pista.removeAttribute('tabindex');
      else pista.setAttribute('tabindex', tabindex);
      delete riel.dataset.miNativo;
    };
    pista.addEventListener('scroll', programar, { passive: true });
    pista.addEventListener('keydown', teclado);
    window.addEventListener('resize', alCambiarAncho, { passive: true });
    programar();
    return api;
  };
})();
